import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const handlePlayGame = () => {
    // Here you can implement your logic for the "Play a Game" button,
    // e.g., redirect to a game page or open a modal.
    alert("Let's Play a Game!");
  };

  return (
    <nav className="bg-black text-white fixed w-full z-10 shadow-md">
      <div className="container mx-auto flex justify-between items-center p-4">
        <h1 className="font-pixelTitle text-2xl font-bold">Rammir Portfolio</h1>

      </div>
    </nav>
  );
}

export default Navbar;
